export default {
    entityKey: 'platform-controls',
    basePath: '/platform-controls',
    titles: {
        singular: 'Platform Control',
        plural: 'Platform Controls'
    }
}
